import { useMemo } from "react";
import {
  getEventColor,
  isOutsideCmpny,
  transformScheduleData,
} from "../components/mypage/scheduler/component/function/common";
import { useSelector } from "react-redux";

const ScheduleTable = ({ data = [], onClickEvent }) => {
  const company = useSelector((state) => state?.company?.data);
  const scheduleList = useMemo(() => transformScheduleData(data), [data]);

  return (
    <table>
      <tbody>
        {Object.entries(scheduleList)
          .sort((a, b) => b[0] - a[0])
          .flatMap(([year, months]) => [
            <tr key={year}>
              <td className="year">{year}년</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>,
            ...Object.entries(months)
              .sort((a, b) => b[0] - a[0])
              .flatMap(([month, days]) => [
                <tr key={`${year}-${month}`}>
                  <td></td>
                  <td className="month">{month}월</td>
                  <td></td>
                  <td></td>
                </tr>,
                ...Object.entries(days)
                  .sort((a, b) => b[0] - a[0])
                  .flatMap(([day, events]) => [
                    <tr key={`${year}-${month}-${day}`}>
                      <td></td>
                      <td></td>
                      <td className="day">{day}일</td>
                      <td></td>
                    </tr>,
                    ...events.map((event, index) => (
                      <tr key={`${year}-${month}-${day}-${index}`}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td
                          className={`event ${isOutsideCmpny(event, company) ? "outside" : ""}`}
                          style={{
                            background: getEventColor(event, company, 0.7),
                            textDecoration: event.completeYn === "Y" ? "line-through" : "none",
                          }}
                          onClick={() => onClickEvent(event)}>
                          <div>
                            <span>
                              {event.title}
                              {event.isProject ? ` (${event.isProject})` : ""}
                            </span>
                            {event.documentNo && event.gbn === "C" && (
                              <div className="doc">
                                <span>{event.documentNo}</span>
                                <p>
                                  <span>
                                    댓글이 달린 일정과, 그 일정에서 복사된 일정에 댓글이 달리면
                                    부여되는 문서번호입니다.
                                  </span>
                                  <span>예: 1 (원본), 1-1 (복사본)</span>
                                </p>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )),
                  ]),
              ]),
          ])}
      </tbody>
    </table>
  );
};

export default ScheduleTable;
